import { tuitionDetailConstants } from '../actions/tuitionDetail.actions';

const initialState = {
  items: [],
  loading: false,
  error: null,
  currentDetail: null,
  statistics: null,
  batchResult: null,
};

export function tuitionDetails(state = initialState, action: any) {
  switch (action.type) {
    case tuitionDetailConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionDetailConstants.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.data,
      };
    case tuitionDetailConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionDetailConstants.GETBYID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionDetailConstants.GETBYID_SUCCESS:
      return {
        ...state,
        loading: false,
        currentDetail: action.data,
      };
    case tuitionDetailConstants.GETBYID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionDetailConstants.CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionDetailConstants.CREATE_SUCCESS: {
      // Upsert: nếu đã tồn tại id → replace (đang sửa), chưa có → thêm mới
      const exists = (state.items as any[]).some((item: any) => item.id === action.data?.id);
      return {
        ...state,
        loading: false,
        items: exists
          ? (state.items as any[]).map((item: any) =>
              item.id === action.data.id ? action.data : item
            )
          : [...state.items, action.data],
      };
    }
    case tuitionDetailConstants.CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionDetailConstants.BATCH_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionDetailConstants.BATCH_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        batchResult: action.data,
      };
    case tuitionDetailConstants.BATCH_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionDetailConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionDetailConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter((item: any) => item.id !== action.id),
      };
    case tuitionDetailConstants.DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionDetailConstants.GET_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionDetailConstants.GET_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        statistics: action.data,
      };
    case tuitionDetailConstants.GET_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
